import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useSelector } from 'react-redux';
import {
  Box, Grid, Stack, useMediaQuery,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import api from '../../../../Http';
import EventButtonContainer from './EventButtonContainer';
import CardInfos from './CardInfos';
import { IconDoor, IconKey } from '../../icons';
import placeHolder from '../../../../eclipse_cross.png';
import ActionsDialog from './ActionDialog';

const CarTab = ({ positionInfo }) => {
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('md'));
  const [modalInfo, setModalInfo] = useState(null);
  const [sucess, setSucess] = useState(false);
  const carId = useSelector((state) => state.devices.selectedId);

  const [livePosition, setLivePosition] = useState(positionInfo);

  async function fetchLatestPosition() {
    if (!carId) return;
    const response = await api.get(`/api/devices?id=${carId}`);
    const { positionId } = response.data[0];

    if (positionId !== undefined) {
      const posResponse = await api.get(`/api/positions?id=${positionId}`);
      setLivePosition({ ...posResponse.data[0] });
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      fetchLatestPosition();
    }, 1000); // 1000ms = 1 segundo
    return () => clearInterval(interval); // limpeza ao desmontar
  }, [carId]);

  useEffect(() => {
    setLivePosition(positionInfo);
  }, [positionInfo]);

  dayjs.extend(duration);
  dayjs.extend(relativeTime);

  async function sendCommand(type) {
    if (!carId) return;

    await api.post('/api/commands/send', {
      deviceId: carId,
      attributes: {},
      type,
    });
    setSucess(true);
  }

  function convertToKM(valueInMetters) {
    return valueInMetters;
  }

  return (
    <>
      {desktop ? (
        <Box width="100%" height="80%" padding="28px 28px 0 28px">
          <img width="100%" alt="Eclipse Cross" src={placeHolder} />
        </Box>
      ) : null}

      <Box width="100%" alignItems="center">
        <Box
          padding="8px 64px 24px 64px"
          width="100%"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          gap={desktop ? '12px' : '8px'}
          overflow={desktop ? 'hidden' : 'auto'}
        >

          {!livePosition?.attributes?.door ? (
            <EventButtonContainer
              callback={() => {
                setModalInfo({ text: 'Imobilizar', icon: 'IconKey', callback: () => sendCommand('engineStop') });
              }}
              text="Fechar"
              icon={<IconDoor />}
            />
          ) : (
            <EventButtonContainer
              callback={() => {
                setModalInfo({ text: 'Liberar', icon: 'IconKey', callback: () => sendCommand('engineResume') });
              }}
              text="Abrir"
              icon={<IconDoor />}
            />
          )}

          {livePosition?.attributes?.ignition ? (
            <EventButtonContainer
              callback={() => {
                setModalInfo({ text: 'Ligar', icon: 'IconKey', callback: () => sendCommand('engineResume') });
              }}
              text="Ligar Motor"
              icon={<IconKey />}
            />
          ) : (
            <EventButtonContainer
              callback={() => {
                setModalInfo({ text: 'Desligar', icon: 'IconKey', callback: () => sendCommand('engineStop') });
              }}
              text="Desligar Motor"
              icon={<IconKey />}
            />
          )}

          <EventButtonContainer
            callback={() => {
              setModalInfo({ text: 'Liberar', icon: 'IconKey', callback: () => sendCommand('openTrunk') });
            }}
            text="Trunk"
            icon={<IconKey />}
          />

        </Box>
      </Box>
      <ActionsDialog sucess={sucess} setSucess={setSucess} modalInfo={modalInfo} setModalInfo={setModalInfo} />

      <Box width="100%">
        {!desktop && (
          <Stack direction="row" spacing="16px" overflow="auto" padding="32px 16px 64px">
            {livePosition?.attributes?.batteryLevel > 0 && (
              <CardInfos name="Nivel de bateria" value={livePosition?.attributes?.batteryLevel} icon="Power" type="percent" />
            )}
            <CardInfos name="Nivel Combustível" value={livePosition?.attributes?.fuel} icon="GasLevel" type="percent" />
            <CardInfos name="Odometro" value={convertToKM(livePosition?.attributes?.odometer)} icon="TripDistance" type="km" />
          </Stack>
        )}

        {desktop && (
          <Grid rowSpacing="24px" spacing="24px" container padding="32px">
            {livePosition?.attributes?.batteryLevel > 0 && (
              <Grid item xs={6}>
                <CardInfos name="Nivel de bateria" value={Math.trunc(livePosition?.attributes?.batteryLevel)} type="percent" icon="Power" />
              </Grid>
            )}
            <Grid item xs={6}>
              <CardInfos name="Nivel Combustível" value={livePosition?.attributes?.fuel} type="percent" icon="GasLevel" />
            </Grid>
            <Grid item xs={6}>
              <CardInfos name="Odometro" value={convertToKM(livePosition?.attributes?.odometer)} type="km" icon="TripDistance" />
            </Grid>
          </Grid>
        )}
      </Box>
    </>
  );
};

export default CarTab;
